import React from 'react';
import { api } from '../lib/api';
import { toast } from './ui/use-toast';
import { ArrowLeft } from 'lucide-react';
import { useHistory } from 'react-router-dom'; // Import useHistory
import Button from "./ui/button";
import Input from "./ui/input";
import Label from "./ui/label";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";

const DatosVehiculo = ({ vehiculo, setVehiculo, setPaso, cliente_id }) => {
 

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // Convertir a número si el tipo es 'number'
    const parsedValue = type === 'number' ? parseInt(value, 10) : value;

    // Actualizar el estado del vehículo
    setVehiculo({ ...vehiculo, [name]: parsedValue });

    console.log(`Campo cambiado: ${name}, Nuevo valor: ${parsedValue}`); // Log para verificar cambios
  };

  const guardarVehiculo = () => {
    console.log('Botón Guardar presionado'); // Verificar que se activa el onClick

    // Verificar que cliente_id esté presente antes de guardar el vehículo
    if (!cliente_id) {
      console.error('Error: cliente_id no está definido'); // Log si falta cliente_id
      toast({ title: 'Error', description: 'El cliente no ha sido asignado correctamente.', variant: 'destructive' });
      return;
    }

    // Agregar el cliente_id al objeto vehiculo
    const vehiculoConClienteId = { ...vehiculo, cliente_id };
    console.log('Datos a enviar al backend:', vehiculoConClienteId); // Log para verificar datos antes de enviarlos

    // Enviar la solicitud POST al servidor para guardar el vehículo
    api.post('/vehiculos', vehiculoConClienteId)
      .then((response) => {
        console.log('Respuesta del servidor: Vehículo guardado correctamente'); // Confirmar éxito
        console.log('Respuesta completa del servidor:', response); // Detallar la respuesta del servidor
        toast({ title: 'Vehículo guardado', description: 'Los datos del vehículo se han guardado correctamente.' });
        
        // Redirigir al home
        window.location.href = '/';
      })
      .catch((error) => {
        console.error('Error al guardar el vehículo:', error.response?.data || error.message); // Log detallado del error
        toast({ title: 'Error', description: 'No se pudo guardar el vehículo.', variant: 'destructive' });
      });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Datos del Vehículo</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="patente">Patente</Label>
          <Input
            id="patente"
            name="patente"
            value={vehiculo.patente || ''}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="marca">Marca del Vehículo</Label>
          <Input
            id="marca"
            name="marca"
            value={vehiculo.marca || ''}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="anio">Año del Vehículo</Label>
          <Input
            id="anio"
            name="anio"
            type="number"
            value={vehiculo.anio || ''}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <Label htmlFor="color">Color</Label>
          <Input
            id="color"
            name="color"
            value={vehiculo.color || ''}
            onChange={handleChange}
            required
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button
          onClick={() => {
            console.log('Botón Anterior presionado, paso cambiado a 2'); // Confirmar cambio de paso
            setPaso(2);
          }}
          variant="outline"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Anterior
        </Button>
        <button 
          onClick={guardarVehiculo} 
          className="bg-blue-500 text-white mt-4 px-4 py-2 rounded"
        >
          Guardar
        </button>
      </CardFooter>
    </Card>
  );
};

export default DatosVehiculo;
